import { Flex } from '@chakra-ui/react';
import { CenterSpinner } from '~/common/components/CenterSpinner';
import { ListingPageContent } from '../../components/Listings/ListingPage/ListingPageContent/ListingPageContent';
import {
  ListingPageContext,
  ListingPageProvider,
} from '../../components/Listings/ListingPage/ListingPageContext';
import { SIDEBAR_WIDTH_COLLAPSED } from '../../components/PageDetailLayout/SidebarItem';

export const ListingPage = () => {
  return (
    <ListingPageProvider>
      <Flex
        alignItems="center"
        backgroundColor="bg.main"
        direction="column"
        flexGrow={1}
        gap={0}
        maxWidth={{
          base: '100vw',
          md: `calc(100vw - ${SIDEBAR_WIDTH_COLLAPSED})`,
        }}
        minHeight="100vh"
        mx="auto"
        width="100%"
      >
        <ListingPageContext.Consumer>
          {({ isLoadingListing }) => {
            if (isLoadingListing) {
              return <CenterSpinner />;
            }

            return <ListingPageContent />;
          }}
        </ListingPageContext.Consumer>
      </Flex>
    </ListingPageProvider>
  );
};
